<template>
  <div class="linha-do-tempo">
    <div class="linha-do-tempo__cabecalho">
      <h2 class="titulo titulo_pequeno">
        {{ titulo }} · {{ itens.length }}
        {{ itens.length === 1 ? rotuloSingular : rotuloPlural }}
      </h2>

      <button
        type="button"
        class="botao botao_cor-cinza botao_sem-preenchimento botao_medio"
        @click="alternarExpandirTudo"
      >
        {{ todosExpandidos ? 'Recolher tudo' : 'Expandir tudo' }}
      </button>
    </div>

    <div v-if="itens.length" class="linha-do-tempo__lista">
      <div
        class="linha-do-tempo__item"
        v-for="(item, index) in itens"
        :key="item.id != null ? item.id : index"
      >
        <span
          class="linha-do-tempo__marcador"
          :class="'linha-do-tempo__marcador_' + (item.corDoMarcador || 'sucesso')"
          aria-hidden="true"
        >
          <i :class="item.icone"></i>
        </span>

        <div
          class="linha-do-tempo__card"
          :class="{
            'linha-do-tempo__card_vinho': item.varianteDoPrazo === 'vencido',
            'linha-do-tempo__card_info': item.varianteDoPrazo === 'prorrogado',
          }"
        >
          <button
            type="button"
            class="linha-do-tempo__cabecalho-item"
            :aria-expanded="itemEstaExpandido(index)"
            @click="alternarItem(index)"
          >
            <span
              v-if="item.titulo"
              :class="[
                'tags',
                item.corDaTag || 'tags_cor-azul',
                { tags_grande: tagsGrandes },
              ]"
            >
              {{ item.titulo }}
            </span>

            <template v-if="item.setorResponsavelAtual">
              <span class="linha-do-tempo__separador-setor" aria-hidden="true">·</span>
              <span :class="['tags', 'tags_cor-cinza', { tags_grande: tagsGrandes }]">
                {{ item.setorResponsavelAtual }}
              </span>
            </template>

            <span class="linha-do-tempo__lado-direito">
              <span class="texto texto_medio texto_cor-cinza-50">
                {{ item.data }}
              </span>

              <i
                class="far linha-do-tempo__chevron"
                :class="itemEstaExpandido(index) ? 'fa-chevron-up' : 'fa-chevron-down'"
                aria-hidden="true"
              ></i>
            </span>
          </button>

          <div v-if="itemEstaExpandido(index)" class="linha-do-tempo__detalhes">
            <hr class="linha-do-tempo__divisor" />

            <span v-if="item.mensagem" class="texto texto_medio texto_cor-cinza-90">{{
              item.mensagem
            }}</span>

            <div v-if="item.observacao" class="linha-do-tempo__observacao">
              <span class="linha-do-tempo__observacao-titulo">
                {{ item.tituloDaObservacao || 'Observação' }}
              </span>
              <span class="linha-do-tempo__observacao-texto">
                {{ item.observacao }}
              </span>
            </div>

            <div class="linha-do-tempo__rodape">
              <span
                v-if="item.responsavel"
                class="linha-do-tempo__responsavel texto texto_pequeno texto_cor-cinza-90"
              >
                Por
                <span class="linha-do-tempo__responsavel-nome">{{ item.responsavel }}</span>
              </span>
              <span v-else />

              <span v-if="item.setorOrigem || item.setorDestino" class="linha-do-tempo__setor">
                <template v-if="item.setorOrigem">
                  <span :class="['tags', 'tags_cor-cinza', { tags_grande: tagsGrandes }]">{{
                    item.setorOrigem
                  }}</span>
                  <i class="far fa-arrow-right" aria-hidden="true"></i>
                </template>
                <span
                  v-if="item.setorDestino"
                  :class="['tags', 'tags_cor-cinza', { tags_grande: tagsGrandes }]"
                >
                  {{ item.setorDestino }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p v-else class="linha-do-tempo__vazio">
      {{ mensagemVazio }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'linha-do-tempo',
  props: {
    itens: {
      type: Array,
      default: () => [],
    },
    titulo: {
      type: String,
      default: 'Histórico Completo',
    },
    rotuloSingular: {
      type: String,
      default: 'movimentação',
    },
    rotuloPlural: {
      type: String,
      default: 'movimentações',
    },
    mensagemVazio: {
      type: String,
      default: 'Não há movimentações registradas.',
    },
    tagsGrandes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      indicesExpandidos: [],
    };
  },
  computed: {
    todosExpandidos() {
      return this.itens.length > 0 && this.indicesExpandidos.length === this.itens.length;
    },
  },
  methods: {
    itemEstaExpandido(index) {
      return this.indicesExpandidos.includes(index);
    },
    alternarItem(index) {
      const posicao = this.indicesExpandidos.indexOf(index);
      if (posicao === -1) {
        this.indicesExpandidos.push(index);
      } else {
        this.indicesExpandidos.splice(posicao, 1);
      }
    },
    alternarExpandirTudo() {
      if (this.todosExpandidos) {
        this.indicesExpandidos = [];
      } else {
        this.indicesExpandidos = this.itens.map((_, index) => index);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// LinhaDoTempo.vue?a3abd14e